import React from "react";

const AboutSection = () => {
  return (
    <>
      <section id="about" className="about-section">
        <div className="container">
          <h2 className="section-title">About FORMAX MONEY</h2>
          <div className="about-content">
            <div className="about-text">
              <p>
                <strong>FORMAX MONEY</strong> is a brand of{" "}
                <strong>FORMAX IT SOLUTIONS PRIVATE LIMITED</strong>, a
                registered Indian company and a{" "}
                <strong>bank-licensed Corporate Business Correspondent</strong>.
                We are authorized by leading banks to appoint BC Agents and
                deliver last-mile banking and financial inclusion services
                across India.
              </p>
              <p>
                Through our extensive BC Agent network, we provide essential
                banking services including{" "}
                <strong>AEPS (Aadhaar Enabled Payment System)</strong>,
                <strong> Domestic Money Transfer (DMT)</strong>,{" "}
                <strong>Cash Management Services (CMS)</strong>, and{" "}
                <strong>UPI Cash Point</strong> to unbanked and underbanked
                communities. Our mission is to bridge the financial divide by
                empowering local entrepreneurs to become Banking Correspondents
                and serve their communities with secure, reliable, and
                affordable banking solutions.
              </p>
              <div className="legal-info">
                <p>
                  <strong>Legal Entity:</strong> FORMAX IT SOLUTIONS PRIVATE
                  LIMITED
                </p>
                <p>
                  <strong>CIN:</strong> U72900WB2018PTC228240 &nbsp;|&nbsp;
                  <strong>GSTIN:</strong> 19AADCF5125F1ZT
                </p>
                <p>
                  <strong>Registered Office:</strong> N0060, Mochpole, Near
                  Junior School, Nabapally, Barasat, Kolkata - 700126, West
                  Bengal, India
                </p>
                <p>
                  <strong>Email:</strong> support@formaxmoney.in
                </p>
              </div>
            </div>
            <div className="about-stats-card">
              <h3>
                <i className="fas fa-chart-line"></i> Why India trusts us
              </h3>
              <ul>
                <li>
                  <i className="fas fa-bank"></i> Licensed Bank BC
                </li>
                <li>
                  <i className="fas fa-handshake"></i> 10+ Partner Banks
                </li>
                <li>
                  <i className="fas fa-headset"></i> 24/7 Agent Support
                </li>
                <li>
                  <i className="fas fa-bolt"></i> Real-time Settlements
                </li>
                <li>
                  <i className="fas fa-rupee-sign"></i> Best-in-class
                  Commissions
                </li>
                <li>
                  <i className="fas fa-users"></i> 10K+ Active BC Agents
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        .about-section {
          background: #ffffff;
          padding: 60px 0;
        }
        .section-title {
          text-align: center;
          font-size: 2.2rem;
          font-weight: 700;
          color: #0A2540;
          margin-bottom: 40px;
          position: relative;
        }
        .section-title:after {
          content: '';
          display: block;
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #D4AF37, #B8960F);
          margin: 15px auto 0;
          border-radius: 4px;
        }
        .about-content {
          display: flex;
          flex-wrap: wrap;
          gap: 48px;
        }
        .about-text {
          flex: 1.5;
          min-width: 260px;
        }
        .about-text p {
          margin-bottom: 20px;
          line-height: 1.6;
          color: #334155;
          font-size: 1rem;
        }
        .legal-info {
          background: #f1f5f9;
          padding: 20px;
          border-radius: 20px;
          margin-top: 20px;
        }
        .legal-info p {
          margin-bottom: 8px;
          font-size: 0.9rem;
        }
        .about-stats-card {
          flex: 1;
          background: linear-gradient(135deg, #0A2540, #1A3A5F);
          padding: 32px;
          border-radius: 32px;
          color: white;
          box-shadow: 0 20px 25px -12px rgba(0,0,0,0.15);
        }
        .about-stats-card h3 {
          font-size: 1.5rem;
          margin-bottom: 24px;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .about-stats-card ul {
          list-style: none;
          padding-left: 0;
        }
        .about-stats-card li {
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          gap: 12px;
          font-weight: 500;
          font-size: 1rem;
        }
        .about-stats-card li i {
          font-size: 1.2rem;
          width: 24px;
          color: #D4AF37;
        }
        @media (max-width: 720px) {
          .about-stats-card h3 { font-size: 1.3rem; }
          .section-title { font-size: 1.8rem; }
        }
      `}</style>
    </>
  );
};

export default AboutSection;
